export enum MessageType {
    AppointmentConfirmation = 0,
    AppointmentReminder,
    AppointmentLookingForwardToSeeingYou,
}
